module.exports = {"handsome":"ZZC,You're handsome"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/en.json
// module id = UpdR
// module chunks = 29